import React from 'react';
import { ReactComponent as MissionIcon } from '../../assets/icons/mission.svg';
import { ReactComponent as VisionIcon } from '../../assets/icons/vision.svg';
import { ReactComponent as ValuesIcon } from '../../assets/icons/values.svg';

const Goals = () => {
  return (
    <div className="container-fluid bg-warning" style={{ paddingTop: '5rem' }}>
      <div className="container">
        <p className="text-center text-secondary">
          What we stand for
        </p>
        <h1 className="text-center text-info">
          <strong>Our goals for our brand </strong>
        </h1>
        <div className="row justify-content-center align-items-top mt-5">
          <div className="col-12 col-md-4 mb-4">
            <div className="bg-white rounded-1 px-4 pt-5 pb-3 h-100">
              <div className="d-flex justify-content-start align-items-center">
                <div>
                  <MissionIcon />
                </div>
                <h3 className="mx-5 text-info">Mission</h3>
              </div>
              <p className="mt-4 text-secondary">
                To supply our customers with quality PET products that meet thier needs at the right price and continously exceed their expectations in quality and delivery.
              </p>
            </div>
          </div>
          <div className="col-12 col-md-4 mb-4">
            <div className="bg-white rounded-1 px-4 pt-5 pb-3 h-100">
              <div className="d-flex justify-content-start align-items-center">
                <div>
                  <VisionIcon />
                </div>
                <h3 className="mx-5 text-info">Vision</h3>
              </div>
              <p className="mt-4 text-secondary">
                To be every PET manufacturer choice distributor while helping customers to meet the needs of beverages industries.
              </p>
            </div>
          </div>
          <div className="col-12 col-md-4 mb-4">
            <div className="bg-white rounded-1 px-4 pt-5 pb-3 h-100">
              <div className="d-flex justify-content-start align-items-center">
                <div>
                  <ValuesIcon />
                </div>
                <h3 className="mx-5 text-info">Core Values</h3>
              </div>
              <p className="mt-4 text-secondary">
                Our culture is present in our operations because of who we are. Our values consist of
<strong>{" "} Attention</strong>, <strong>Integrity</strong>, <strong>Proficiency</strong>, <strong>Respect</strong>, <strong>Firm</strong>, <strong>Dependability</strong> and <strong>Passion</strong>.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export { Goals };
